module.exports = __webpack_public_path__ + "static/media/View_Beneficiary.2486f87c.svg";